import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router";
import { useBranding } from "../../branding/useBranding";
import RefreshButton from "../../components/buttons/RefreshButton";
import FAQButton from "../../components/buttons/FAQButton";
import { useAtom } from "jotai";
import { highContrastAtom } from "../../jotai/atoms";

interface MobileNavbarState {
  back?: boolean;
  title?: string;
}

export default function MobileNavbar({ drawerId }: { drawerId: string }) {
  const branding = useBranding();
  const navigate = useNavigate();
  const { pathname, state } = useLocation();
  // We need a way to back more dynamic state to the Mobile Navbar without passing props
  // everywhere up and down the DOM tree.
  const { back, title } = (state as MobileNavbarState) || {};
  const [showBack, setShowBack] = useState(false);
  const [headerTitle, setHeaderTitle] = useState<string>();
  const [highContrast] = useAtom(highContrastAtom);

  const getHeaderTitle = () => {
    if (pathname === "/home/search/newsearch") {
      return "Search Records";
    } else if (pathname === "/home/search/altcontacts") {
      return "Verification Needed";
    } else if (pathname === "/home/search/enterpin") {
      return "Enter PIN";
    } else if (title) {
      return title;
    }
    return undefined;
  };

  useEffect(() => {
    const navBackUrls = [
      "/home/search/newsearch",
      "/home/search/altcontacts",
      "/home/search/enterpin",
      "/home/records/events",
    ];
    setShowBack(navBackUrls.includes(pathname) || !!back);
    setHeaderTitle(getHeaderTitle());
  }, [pathname, back, title]);

  const ActionButtons = () => {
    if (pathname === "/home/search") {
      return (
        <div className="w-1/5 my-auto" onClick={() => navigate("/home/search/newsearch")}>
          <img className="ml-auto" src="/assets/images/plus-solid.svg" />
        </div>
      );
    } else if (
      location?.pathname === "/home/records" ||
      location?.pathname === "/home/records/screening"
    ) {
      return (
        <div className="ml-auto w-1/5 my-auto flex docket-gap-1">
          <RefreshButton />
          <FAQButton />
        </div>
      );
    }

    return <div className="w-1/5" />;
  };

  return (
    <div
      data-testid="mobile-navbar"
      className="md:hidden flex drawer-content min-h-18 px-6 py-3 fixed top-0 w-full docket-mobile-navbar z-10"
    >
      {showBack ? (
        <div className="w-1/5 my-auto" onClick={() => navigate(-1)}>
          <img className="mr-auto h-6" src="/assets/images/chevron_left_white.png" />
        </div>
      ) : (
        <label htmlFor={drawerId} className="drawer-overlay w-1/5 my-auto">
          <img className="h-8" src="/assets/images/burger_menu.png" />
        </label>
      )}

      <div className="w-3/5 my-auto">
        {!headerTitle ? (
          <img
            className="mx-auto h-12"
            src={`/${highContrast ? branding.mobileHeaderImageHighContrast : branding.headerImage}`}
            alt="Docket logo"
            onClick={() => navigate("/home")}
          />
        ) : (
          <p className="text-white font-semibold text-center text-xl whitespace-nowrap">
            {headerTitle}
          </p>
        )}
      </div>
      <ActionButtons />
    </div>
  );
}
